<template>
    <div class="main_center" style="margin: 0px 0px; padding-top: 8px;">
        <PmSearch ref="searchRef"
                  :form.sync="form"
                  :options.sync="searchConfigs"
                  label-width="72px"
                  @reset="resetSearch"
                  @search="seachBtn">
            <template v-slot:purchaseItemSlot="purchaseItemSlot">
                <div class="multiple-item-wrap">
                    <el-select v-model="form.purchaseItemId" filterable :filter-method="filterOption" placeholder="请选择" style="width: 100%">
                        <el-option-group
                                style="width: 100%"
                                v-for="group in purchaseCatalogList"
                                :key="group.label"
                                :label="group.label">
                            <el-option
                                    v-for="item in group.options"
                                    style="width: 100%"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: right">{{ item.name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div>
            </template>
        </PmSearch>
        <div class="content">
            <el-table
                :data="tableData"
                v-loading="dataListLoading"
                ref="multipleTable"
                :height="tableMaxHeight"
                stripe
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    fixed
                    label="序号"
                    type="index"
                    :index="indexMethod"
                    width="50"
                    align="center"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" align="left" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            title="查看"
                            @click="routerDetail(scope.row)"
                        >查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        label="采购需求编号"
                        prop="projectCode"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="采购需求名称"
                    prop="projectName"
                    align="left"
                    min-width="180"
                    :show-overflow-tooltip="true"
                ></el-table-column>

                <el-table-column
                    label="采购品目"
                    prop="purchaseItemId"
                    header-align="left"
                    align="left"
                    width="120"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.purchaseItem.purchaseItemName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="采购方式"
                    prop="purchaseModeName"
                    header-align="left"
                    align="left"
                    width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="预算金额（元）"
                        prop="purchaseBudget"
                        header-align="left"
                        align="left"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="修改人"
                        prop="updateUser"
                        header-align="left"
                        align="left"
                        min-width="120"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    prop="updateTime"
                    header-align="left"
                    align="left"
                    min-width="150"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    header-align="left"
                    align="left"
                    min-width="150"
                    :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            ></pagination>
        </div>
    </div>
</template>

<script>
import { httpMixinsList,httpSuiteLoadDicts,httpSysPurcatalogList} from "@/server/purchase"
import Pagination from "@/components/Pagination.vue";
import PmSearch from "@/components/PmSearch/index.vue";
import {formatSuiteDictOptionsData } from '@/utils/index';
export default {
    name: "busWitnessTable",
    components: {
        Pagination,
        PmSearch
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 275,
            dataListLoading: false,
            form: {},
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 0, //总条数
            tableData: [],
            multipleSelection: [],
            formData: {},
            purchaseCatalogList:[],
            purchaseCatalogListCopy:[],
            searchConfigs:[
                {
                    type:'input',
                    key:'projectCode',
                    label:'需求编号',
                },
                {
                    type:'input',
                    key:'projectName',
                    label:'需求名称',
                    options:[],
                },
                {
                    key:'purchaseItemId',
                    label:'采购品目',
                    slot:'purchaseItemSlot',
                },
                {
                    type:'select',
                    key:'purchaseMode',
                    label:'采购方式',
                    options:[],
                },
            ],
        };
    },
    filters: {
        ellipsis(text, num) {
            if (text.length > num) {
                return text.substring(0, num) + "...";
            } else {
                return text;
            }
        }
    },
    activated() {
        this.getDataList();
    },
    created() {
        this.getDicData()

    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
        that.ifmove();
    },
    methods: {
        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 328 + 41;
            this.pageSize = parseInt(tableMaxHeight / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
        },
        filterOption(query) {
            this.purchaseCatalogList = JSON.parse(JSON.stringify(this.purchaseCatalogListCopy));
            this.purchaseCatalogList.forEach(group => {
                group.options = group.options.filter(option =>
                    option.name.toLowerCase().includes(query.toLowerCase()) || option.value.toLowerCase().includes(query.toLowerCase())
                );
            });
        },
        getDicData(){
            httpSuiteLoadDicts('purmethod_cgxq').then((res) => {
                let data = formatSuiteDictOptionsData(res.data,{label:'全部',value:undefined});
                this.$refs.searchRef.setSearchConfigsData('purchaseMode','options',data);
            })
            httpSysPurcatalogList({}).then((res) => {
                this.purchaseCatalogList = res.data;
                this.purchaseCatalogListCopy = JSON.parse(JSON.stringify(res.data));
            })
        },
        getDataList() {
            // 获取列表数据
            this.dataListLoading = true;
            httpMixinsList("/purchase/project/pagedList", {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    filter: {
                        backState:1,
                        ...this.form
                    }
                })
                .then((data) => {
                    this.dataListLoading = false;
                    if (data) {
                        this.tableData = data.data.rows || [];
                        this.total = data.data.total || 0;
                        this.$refs.multipleTable.doLayout();
                    }
                });
        },

        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        paginationChange(obj) {
            this.pageIndex = obj.page || 1;
            this.pageSize = obj.limit || 5;
            this.getDataList();
        },

        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        resetSearch(){
            this.form.purchaseItemId = '';
        },
        //搜索按钮
        seachBtn() {
            this.pageIndex = 1;
            this.getDataList();
        },
        reflash() {
            //刷新按钮
            this.pageIndex = 1;
            this.form = {}
            this.getDataList();
        },
        routerDetail(item) {
            // 跳转详情
            var id = item.id;
            this.$router.push({
                name: "purchaseRequiresDetail",
                query: {
                    id: id,
                }
            });
        },

    },

    destroyed() {
        window.onresize = null;
    }
};
</script>
<style lang="less" scoped>


</style>
